import type { Resource } from "i18next";

export const extractNamespaces = (obj: Resource) => Object.keys(obj[Object.keys(obj)[0]]);
